import React, {Suspense, memo} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type StaticBannerInnerContainerProps = {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
    children?: React.ReactNode
    hasQuickLinks?: boolean
    countrySelectEnabled?: boolean
}

const StaticBannerInnerContainer = memo(
    ({templating, children, hasQuickLinks, countrySelectEnabled}: StaticBannerInnerContainerProps) => {
        const {mainTemplate, fallbackTemplate} = templating
        const TemplatedStaticBannerInnerContainer = useTemplatedComponent({mainTemplate, fallbackTemplate}, MANIFEST)
        const componentProps = {
            hasQuickLinks,
            countrySelectEnabled,
        }

        return (
            <Suspense>
                <TemplatedStaticBannerInnerContainer {...componentProps}>
                    {children}
                </TemplatedStaticBannerInnerContainer>
            </Suspense>
        )
    },
)

StaticBannerInnerContainer.displayName = "StaticBannerInnerContainer"

export default connect(StaticBannerInnerContainer)
